import actionTypes from 'constants/actionTypes'

interface LoggingOutState {
  isFetching: boolean
}

interface LoggingOutAction {
  type: string
}

const initialState: LoggingOutState = {
  isFetching: false,
}

export default (state: LoggingOutState = initialState, action: LoggingOutAction): LoggingOutState => {
  if (action.type === actionTypes.AUTH.LOGOUT.REQUEST) {
    return { isFetching: true }
  }
  if (action.type === actionTypes.AUTH.LOGOUT.RECEIVE) {
    return { isFetching: false }
  }
  if (action.type === actionTypes.AUTH.LOGOUT.FAIL) {
    return { isFetching: false }
  }
  return state
}
